import { useState, useMemo } from 'react';

export default function ModalAsignar({ item, usuarios, usuarioId, onChangeUsuario, onSubmit, onClose }) {
  const [busqueda, setBusqueda] = useState('');
  const getTitulo = () => {
    if (item.marca && item.modelo) return `${item.marca} ${item.modelo}`;
    if (item.numero_tarjeta) return `Tarjeta ${item.numero_tarjeta}`;
    return '—';
  };

  // Filtra y ordena alfabéticamente
  const usuariosFiltrados = useMemo(() => {
    const filtrados = busqueda.trim()
      ? usuarios.filter(u =>
        u.nombre_completo?.toLowerCase().includes(busqueda.toLowerCase()) ||
        u.usuario?.toLowerCase().includes(busqueda.toLowerCase())
      )
      : usuarios;
    return [...filtrados].sort((a, b) =>
      a.nombre_completo?.localeCompare(b.nombre_completo, 'es')
    );
  }, [usuarios, busqueda]);
  if (!item) return null;
  const usuarioSeleccionado = usuarios.find(u => String(u.id) === String(usuarioId));

  return (
    <div className="overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ width: 480 }}>
        <h3 style={{ marginTop: 0 }}>Asignar — {getTitulo()}</h3>

        {/* Campo de búsqueda */}
        <div style={{ marginBottom: 8 }}>
          <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4 }}>
            Buscar usuario
          </label>
          <input
            className="form-input"
            placeholder="Escribe nombre o usuario..."
            value={busqueda}
            onChange={e => { setBusqueda(e.target.value); onChangeUsuario(''); }}
            autoFocus
          />
        </div>

        {/* Lista filtrada */}
        <div style={{
          border: '1px solid #ccc', borderRadius: 4,
          maxHeight: 240, overflowY: 'auto',
          marginBottom: 12
        }}>
          {usuariosFiltrados.length === 0 ? (
            <div style={{ padding: '12px', color: '#888', fontSize: 13, textAlign: 'center' }}>
              Sin resultados
            </div>
          ) : (
            usuariosFiltrados.map(u => (
              <div
                key={u.id}
                onClick={() => onChangeUsuario(String(u.id))}
                style={{
                  padding: '8px 12px',
                  cursor: 'pointer',
                  fontSize: 13,
                  background: String(usuarioId) === String(u.id) ? '#e8f4fd' : 'transparent',
                  borderLeft: String(usuarioId) === String(u.id) ? '3px solid #007bff' : '3px solid transparent',
                  borderBottom: '1px solid #f0f0f0',
                  display: 'flex', flexDirection: 'column', gap: 2,
                }}
              >
                <span style={{ fontWeight: String(usuarioId) === String(u.id) ? 600 : 400 }}>
                  {u.nombre_completo}
                </span>
                <span style={{ fontSize: 11, color: '#888' }}>
                  {u.usuario} {u.area_nombre ? `— ${u.area_nombre}` : ''}
                </span>
              </div>
            ))
          )}
        </div>

        {/* Usuario seleccionado */}
        {usuarioSeleccionado && (
          <div style={{
            background: '#e8f4fd', border: '1px solid #b8d9f5',
            borderRadius: 4, padding: '6px 10px', fontSize: 12,
            color: '#0056b3', marginBottom: 12
          }}>
            ✓ Seleccionado: <b>{usuarioSeleccionado.nombre_completo}</b>
          </div>
        )}

        <form onSubmit={onSubmit}>
          <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
            <button type="button" className="btn-secondary" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn-primary" disabled={!usuarioId}>Asignar</button>
          </div>
        </form>
      </div>
    </div>
  );
}